import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class AppointmentService {
  fetchAppointment = (params) => {
    return fetch(config.config.endpointUrls.fetchAppointment(params), {
      method: 'GET'
    })
  }
  fetchAppointments = (params) => {
    return fetch(config.config.endpointUrls.fetchAppointments(params), {
      method: 'GET'
    })
  }
  fetchAppointmentWithNoCustomerData = (params) => {
    return fetch(config.config.endpointUrls.fetchAppointmentWithNoCustomerData(params), {
      method: 'GET'
    })
  }
  createAppointment = (fields) => {
    return fetch(config.config.endpointUrls.createAppointment(), {
      method: 'POST',
      body: fields
    })
  }
  updateAppointment = ({ id, ...fields }) => {
    return fetch(config.config.endpointUrls.updateAppointment({ id }), {
      method: 'PATCH',
      body: fields
    })
  }
  cancelAppointment = ({ id }) => {
    return fetch(config.config.endpointUrls.cancelAppointment({ id }), {
      method: 'POST'
    })
  }
  fetchVideoToken = (params) => {
    return fetch(config.config.endpointUrls.fetchVideoToken(params), {
      method: 'POST',
      body: { ...params }
    })
  }
}

export default new AppointmentService()



// WEBPACK FOOTER //
// ../src/services/appointmentService/appointmentService.js